



























































import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import Size from "@/models/size";
import FormValidations from "@/helpers/validations";
import { cloneDeep } from "lodash";

@Component
export default class SizeForm extends Vue {
  @Prop({ default: "sizes.new_size" }) title!: string;
  @Prop() initialSize?: Size;

  size: Size = new Size();
  formValidations = new FormValidations();
  loading = false;

  created(): void {
    if (this.initialSize) this.size = cloneDeep(this.initialSize);
  }

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
    validForm ? this.save() : null;
  }

  @Emit()
  save(): Size {
    return this.size;
  }
  @Emit()
  cancel(): null {
    return null;
  }
}
